import { Head } from "@inertiajs/react";
import { useState } from "react";
import { Box, Heading, Button, Text, Flex, Image, Link } from "@chakra-ui/react";

import inertiaSvg from "/assets/inertia.svg";
import reactSvg from "/assets/react.svg";
import viteRubySvg from "/assets/vite_ruby.svg";

export default function InertiaExample({ name }: { name: string }) {
  const [count, setCount] = useState(0);

  return (
    <>
      <Head title="Inertia + Vite Ruby + React Example" />

      <Box textAlign="center" p={8}>
        <Heading as="h1" size="3xl" mb={8}>
          Hello {name}!
        </Heading>

        <Flex justifyContent="center" gap={6} mb={8}>
          <Link href="https://inertia-rails.dev" target="_blank" rel="noreferrer">
            <Image
              src={inertiaSvg}
              alt="Inertia logo"
              h="120px"
              _hover={{ filter: "drop-shadow(0 0 2em #646cffaa)" }}
            />
          </Link>
          <Link href="https://vite-ruby.netlify.app" target="_blank" rel="noreferrer">
            <Image
              src={viteRubySvg}
              alt="Vite Ruby logo"
              h="120px"
              _hover={{ filter: "drop-shadow(0 0 2em #646cffaa)" }}
            />
          </Link>
          <Link href="https://react.dev" target="_blank" rel="noreferrer">
            <Image src={reactSvg} alt="React logo" h="120px" _hover={{ filter: "drop-shadow(0 0 2em #61dafbaa)" }} />
          </Link>
        </Flex>

        <Heading as="h2" size="xl" mb={6}>
          Inertia + Vite Ruby + React
        </Heading>

        <Box mb={6}>
          <Button
            onClick={() => setCount((count) => count + 1)}
            bg="primary-base"
            color="on-primary-base"
            _hover={{ bg: "primary-hover" }}
            size="lg"
            mb={4}
          >
            count is {count}
          </Button>
          <Text>
            Edit <code>app/frontend/pages/InertiaExample.jsx</code> and save to test HMR
          </Text>
        </Box>
        <Text color="gray.600" fontSize="sm">
          Click on the Inertia, Vite Ruby, and React logos to learn more
        </Text>
      </Box>
    </>
  );
}
